import React from "react";
import { useTranslation } from "react-i18next";
import { getCookie } from "../../../../util/cookie/cookies";

export const AboutBuisness = () => {
    const lang = getCookie('HYUNDAILANG')
    const {t} = useTranslation()
    return(
        <>
        <div className="contentBox">
            <div>
                <div className="left stickyBox">
                    {lang === 'kr'? 
                    <h3>
                        <span>현대엔테크의 사업장을</span>
                        안내해드립니다.
                    </h3>
                    :
                    <h3>
                        Let me introduce you to the business establishment in HyundaiEnTech.
                    </h3>
                    }
                    
                    <ul className="tabBtnBox">
                        <li className="active">{t("about_business_1")}</li>
                    </ul>
                </div>
                <div className="right">
                    <div className="mapBox">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d409.0049960994474!2d127.56438747852506!3d34.9054464680673!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x356e0be5083768e9%3A0xb1f83ccbbca76e64!2z7KO87Iud7ZqM7IKsIO2YhOuMgOyXlO2FjO2BrA!5e0!3m2!1sko!2skr!4v1696486855476!5m2!1sko!2skr" style={{border : '0'}} loading="lazy"></iframe>
                    </div>
                    <div className="tableWrap">
                        <table>
                            <tbody>
                                <tr>
                                    <th>
                                        <span>{t("about_business_2")}</span>
                                    </th>
                                    <td>{t("about_business_3")}</td>
                                </tr>
                                <tr>
                                    <th>
                                        <span>{t("about_business_4")}</span>
                                    </th>
                                    <td>+82-61-724-8757~8</td>
                                </tr>
                                <tr>
                                    <th>
                                        <span>{t("about_business_5")}</span>
                                    </th>
                                    <td>+82-61-724-2566</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}